var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "psychology-tea-campus" },
    [
      _c(
        "a-tabs",
        { attrs: { activeKey: _vm.tabKey }, on: { change: _vm.onTabChange } },
        _vm._l(_vm.tabList, function (item) {
          return _c(
            "a-tab-pane",
            { key: item.key, attrs: { tab: item.tab } },
            [_c(item.key, { tag: "component" })],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }